import { sizes } from '@bnnvara/breakpoints';
import head from 'lodash/head';
import isString from 'lodash/isString';
import last from 'lodash/last';

const possibleSizes = Object.values(sizes);

/**
 * Replaces {format} with the provided width in a source URL.
 *
 * @param {*} source
 * @param {*} width
 * @param {*} ratio
 */
const resize = (source, width, ratio) => {
  const dimensionOptions = [`w_${width}`];

  if (ratio) {
    const height = Math.round(width / ratio);
    dimensionOptions.push(`h_${height}`);
  }
  return isString(source)
    ? source.replace('{format}', dimensionOptions.join(','))
    : source;
};

/**
 * Resizes an image based on the given (optional) width.
 * If a width is not provided, it will return the size most suitable
 * for the current browser's window size.
 *
 * If the function is used during SSR it will also return the largest
 * possible size based on the available breakpoints.
 *
 * @param {*} source
 * @param {*} width
 * @param {*} ratio
 */
const resizeImageSource = (source, width, ratio) => {
  if (!isString(source)) {
    return source;
  }

  if (width) {
    return resize(source, width, ratio);
  }

  if (!process.browser) {
    const maxWidth = last(possibleSizes);
    return resize(source, maxWidth, ratio);
  }

  const closestBreakpointWidth =
    head(possibleSizes.filter((size) => size > window.innerWidth)) ||
    last(possibleSizes);

  return resize(source, closestBreakpointWidth, ratio);
};

/**
 * Returns the largest possible size based on the available breakpoints.
 *
 * @param {*} source
 */
export const resizeImageSourceMax = (source, ratio) =>
  resizeImageSource(source, ratio);

export default resizeImageSource;
